import React, { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent } from "./ui/sheet";
import Sidebar from "./Sidebar";
import BrandMark from "./BrandMark";

/**
 * Mobile top bar with a hamburger that opens the customer Sidebar in a sheet.
 * Hidden on lg+ screens so desktop stays exactly as-is.
 */
export default function MobileTopBar({ title = "AuthorOS" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-brand-hair bg-brand-ink/95 px-4 backdrop-blur lg:hidden">
        <button
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-brand-hair text-brand-ivory hover:border-brand hover:text-brand"
        >
          <Menu className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-2">
          <BrandMark size={26} />
          <span className="font-serif-display text-[15px]">{title}</span>
        </div>
        <div className="w-9" />
      </header>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-[280px] max-w-[85vw] border-r border-brand-hair bg-brand-panel p-0 text-brand-ivory">
          <div onClick={() => setOpen(false)}>
            <Sidebar inSheet />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
